<template>
    <v-layout justify-space-between>
        <v-text-field
            class="verification-code-field"
            :disabled="pageLoading"
            :rules="rules"
            :label="lang.verification_code_text"
            solo
            v-model="code"
        ></v-text-field>

        <template v-if="type === 'image'">
            <v-btn
                disabled
                :loading="isCaptchaLoading"
                block
                class="ma-0 btn-h48 verification-code-image"
                v-if="isCaptchaLoading"
            ></v-btn>
            <v-img
                class="btn-h48 verification-code-image"
                :src="captchaSrc"
                @click="refresh"
                v-else
            ></v-img>
        </template>
        <v-btn
            :disabled="disabled || !ended || pageLoading"
            :loading="sending"
            color="info"
            class="ma-0 btn-h48"
            @click="sendVCode"
            v-else
        >
            {{ sendBtnText }}
        </v-btn>
    </v-layout>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
    name: "VerificationCode",
    data() {
        return {
            captchaSrc: "",
            isCaptchaLoading: false,
            code: "",
            max: parseInt(process.env.VUE_APP_VERIFICATION_CODE_COUNTDOWN),
            time: Date.now(),
            seconds: null,
            timer: null,
            sending: false,
            ended: true
        };
    },
    props: {
        type: {
            type: String,
            default: "mobile" // image,mobile,email
        },
        params: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            default: true
        },
        error: {
            type: Boolean,
            default: false
        },
        stop: {
            type: Boolean,
            default: false
        },
        value: {
            type: String
        }
    },
    computed: {
        ...mapState(["pageLoading", "pageParent", "authVerifiedType"]),
        ...mapGetters(["lang", "isRtl"]),
        sendBtnText() {
            let tmp = this.lang.verification_code_text;
            if (!this.ended) {
                tmp = this.lang.resend_text;
                if (this.seconds) {
                    tmp += "(" + this.seconds + ")";
                }
            }
            return tmp;
        },
        rules() {
            let tmp = [];
            tmp.push(v => !v && this.lang.empty_verification_code_tips);
            tmp.push(
                () => this.error && this.lang.iscorrect_verification_code_tips
            );
            return tmp;
        },
        action() {
            let tmp;
            switch (this.authVerifiedType) {
                case "verification":
                    tmp =
                        this.pageParent === "password"
                            ? this.sendCodeFFTR
                            : this.sendCodeFVS;
                    break;
                case "password":
                    tmp = this.sendCodeFPTS;
                    break;
                case "email":
                    tmp = this.sendCodeFSS;
                    break;
                case "mobile":
                    tmp = this.sendCodeFSS;
                    break;
                case "question":
                    tmp = this.sendCodeFSS;
                    break;
            }
            return tmp;
        },
        getCaptcha() {
            if (this.pageParent === "password") {
                return this.getCaptchaFFTR;
            } else {
                return this.getCaptchaFPTS;
            }
        }
    },
    watch: {
        value(val) {
            this.code = val;
        },
        code(val) {
            this.$emit("input", val);
        },
        sending(val) {
            this.$emit("send", val);
        },
        error(val) {
            if (!val) {
                return;
            }
            this.code = "";
            if (this.type === "image") {
                this.refresh();
            }
        },
        stop(val) {
            if (val) {
                clearInterval(this.timer);
                this.sending = false;
                this.ended = true;
                this.seconds = this.max;
            }
        }
    },
    methods: {
        ...mapActions([
            "getCaptchaFPTS",
            "sendCodeFPTS",
            "sendCodeFVS",
            "sendCodeFSS",
            "getCaptchaFFTR",
            "sendCodeFFTR"
        ]),
        refresh() {
            if (this.isCaptchaLoading) {
                return;
            }
            this.isCaptchaLoading = true;
            this.getCaptcha()
                .then(res => {
                    this.captchaSrc = res.captcha;
                    this.isCaptchaLoading = false;
                })
                .catch(() => {
                    this.isCaptchaLoading = false;
                });
        },
        sendVCode() {
            if (this.sending || this.pageLoading || !this.ended) {
                return;
            }
            this.sending = true;
            this.ended = false;
            this.action(
                Object.assign({}, this.params, {
                    type: this.type
                })
            )
                .then(() => {
                    this.sending = false;
                    this.countDown();
                })
                .catch(err => {
                    this.ended = true;
                    this.sending = false;
                    this.$emit("error", err);
                });
        },
        countDown() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.seconds = this.max;
            this.timer = setInterval(() => {
                this.seconds -= 1;
                if (this.seconds <= 0) {
                    clearInterval(this.timer);
                    this.ended = true;
                    this.seconds = this.max;
                }
            }, 1000);
        }
    },
    created() {
        if (this.type === "image") {
            this.refresh();
        }
    }
};
</script>
<style>
.verification-code-field {
    max-width: 50%;
}
.verification-code-image {
    max-width: 30%;
}
</style>
